/**
 * Renovation Phase Configuration
 * 
 * Single source of truth for renovation project status/phase column definitions.
 * This file defines the visual appearance and properties of each phase column
 * in the renovation projects Kanban board.
 */

import { ProjectStatus } from 'shared/types/renovation';

export interface RenovationPhaseColumn {
  id: ProjectStatus;
  label: string;
  color: string;
  bgColor: string;
  headerBgColor: string;
  borderColor: string;
}

/**
 * Renovation Phase Columns
 * Defines all available project status/phase columns with their styling
 */
export const renovationPhaseColumns: RenovationPhaseColumn[] = [
  {
    id: ProjectStatus.DESIGN,
    label: 'Ontwerp',
    color: 'text-blue-700',
    bgColor: 'bg-blue-50/50',
    headerBgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
  },
  {
    id: ProjectStatus.PLANNED,
    label: 'Uitvoeringsdossier',
    color: 'text-purple-700',
    bgColor: 'bg-purple-50/50',
    headerBgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
  },
  {
    id: ProjectStatus.IN_PROGRESS,
    label: 'In uitvoering - Werf',
    color: 'text-moss-primary',
    bgColor: 'bg-moss-primary/5',
    headerBgColor: 'bg-moss-primary/10',
    borderColor: 'border-moss-primary/20',
  },
  {
    id: ProjectStatus.COMPLETED,
    label: 'Voorlopige oplevering',
    color: 'text-status-good',
    bgColor: 'bg-status-good/5',
    headerBgColor: 'bg-status-good/10',
    borderColor: 'border-status-good/20',
  },
  {
    id: ProjectStatus.PAID,
    label: 'Definitieve oplevering (Volledig gefactureerd)',
    color: 'text-brick-primary',
    bgColor: 'bg-brick-primary/5',
    headerBgColor: 'bg-brick-primary/10',
    borderColor: 'border-brick-primary/20',
  },
];

